import React, { Component } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

export default class ImportCell extends Component {
  renderData = () => {
    var { listitem } = this.props;

    delete listitem["rowno"];
    delete listitem["hasErrors"];

    let tData = [];
    for (const obj in listitem) {
      tData.push(<td key={obj}>{listitem[obj]}</td>);
    }

    return tData;
  };

  render() {
    var { listitem } = this.props;

    return (
      <tr
        style={
          listitem.hasErrors && listitem.hasErrors.length > 0
            ? { backgroundColor: "#ff000038" }
            : {}
        }
      >
        <td>
          <div className="vertical-align-center">
            {listitem.rowno}{" "}
            {listitem.hasErrors && listitem.hasErrors.length > 0 ? (
              <OverlayTrigger
                id="overlay-trigger"
                key="refresh"
                placement="top"
                overlay={
                  <Popover id="popover-basic">
                    {listitem.hasErrors.join(", ")}
                  </Popover>
                }
              >
                <i
                  className="fa fa-exclamation-circle"
                  aria-hidden="true"
                  style={{ float: "right", color: "red", margin: 7 }}
                ></i>
              </OverlayTrigger>
            ) : (
              ""
            )}
          </div>
        </td>
        {/* <td>{listitem.sessiondate}</td>
        <td>{listitem.sessiontrack}</td>
        <td>{listitem.sessiontitle}</td>
        <td>{listitem.sessionstime}</td>
        <td>{listitem.sessionetime}</td>
        <td>{listitem.location}</td>
        <td>{listitem.description}</td> */}
        {this.renderData()}
      </tr>
    );
  }
}
